import React from 'react';
import { cs } from '@bbkAdminUtils/css-utils';
import { Icons } from '@bbkAdminUtils/icons';

import '@bbkAdminStylesheets/icon.scss';

export type IconName = keyof typeof Icons;
type Props = {
  name: IconName;
  class?: string;
};

const Icon: React.FC<Props> = (props) => {
  const { name, class: classes } = props;
  return <div className={cs('bbk-icon', classes)}>{Icons[name]}</div>;
};

export default Icon;
